import FadingImg from '../../../../sharedComponents/fadingImg/FadingImg.vue'
import * as d3 from 'd3-selection'
export default {
  components: {
    FadingImg
  },
  name: 'Background',
  data () {
    return {
      assetsFolder: '../assets/',
      imgs: []
    }
  },
  computed: {
  },
  mounted () {
    this.$nextTick(this.init)
  },
  methods: {
    getRandom () {
      return 0.1 + Math.random() * 0.7
    },
    init () {
      this.imgs.push(d3.select('#bg-0'))
      this.imgs.push(d3.select('#bg-1'))
      this.imgs.push(d3.select('#bg-2'))
      this.imgs.push(d3.select('#bg-3'))
      setTimeout(this.nextAnim, 5000)
    },
    nextAnim () {
      const el = this.imgs[parseInt(Math.random() * this.imgs.length)]
      el.style('opacity', this.getRandom())
      // el.setAttribute('style', 'opacity: ' + this.getRandom() + ';')
      setTimeout(this.nextAnim, 2000 + Math.random() * 6000)
    }
  }
}
